import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { tokenStore } from "@/lib/api";
import { trackSignup } from "@/lib/analytics";

const AuthContext = createContext(null);

function applyUserTheme() {
  document.documentElement.setAttribute("data-theme", "gold"); // zlatá je jediná téma
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, obj = logged in

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data); applyUserTheme(data.theme);
    } catch (e) {
      setUser((prev) => (prev && typeof prev === "object" ? prev : false));
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password, remember = true) => {
    const { data } = await api.post("/auth/login", { email, password });
    tokenStore.set(data.access_token, data.refresh_token, remember);
    let profile = data;
    try { profile = (await api.get("/auth/me")).data; } catch (e) { console.warn("auth/me after login failed, using login payload", e); }
    setUser(profile); applyUserTheme(profile.theme);
    return profile;
  };

  const register = async (email, password, name, extra = {}) => {
    let attribution = null;
    try { attribution = JSON.parse(localStorage.getItem("apis_attribution") || "null"); } catch { attribution = null; }
    const { data } = await api.post("/auth/register", { email, password, name, attribution, ...extra });
    tokenStore.set(data.access_token, data.refresh_token, true);
    let profile = data;
    try { profile = (await api.get("/auth/me")).data; } catch (e) { console.warn("auth/me after register failed", e); }
    setUser(profile); applyUserTheme(profile.theme);
    try { trackSignup(); } catch (e) { console.debug("signup tracking skipped", e); }
    return profile;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("logout request failed, clearing session locally", e); }
    tokenStore.clear();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, check }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
